import { ViewModel, View } from "binder"
import { stringIsNullOrEmpty, translate } from "src/common/utilities";
import { DebitCardSelectorViewModel } from "src/erp/arap/rawData/debitCard/debitCardSelector-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { IGateway, IReceiveInfoProvider } from "../IGateway";
import { DebitGatewayView } from "./debitGateway-view"

export class DebitGatewayViewModel extends ViewModel implements IGateway {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.debitCardSelector = new DebitCardSelectorViewModel(this);
    }
    get title(): string {
        return translate("debitGateway-viewModel.cardTransfer", {})
    }

    GetDefaultView(): View<ViewModel> {
        return new DebitGatewayView();
    }
    public getTypeId(): string {
        return "VM-B0C51695-C771-4EEF-A8CD-ADF6ED076768"
    }
    initialLoad(): void {
        this.debitCardSelector = new DebitCardSelectorViewModel(this);
    }

    public set sourceCardNo(v: string) { this._sourceCardNo = v; } public get sourceCardNo(): string { return this._sourceCardNo; } private _sourceCardNo: string;
    public set traceCode(v: string) { this._traceCode = v; } public get traceCode(): string { return this._traceCode; } private _traceCode: string;
    public set debitCardSelector(v: DebitCardSelectorViewModel) { this._debitCardSelector = v; } public get debitCardSelector(): DebitCardSelectorViewModel { return this._debitCardSelector; } private _debitCardSelector: DebitCardSelectorViewModel;


    async save(dataProvider: IReceiveInfoProvider): Promise<any> {
        return await ServerConnection.callServer('Complex/ArapServices/CreateDebitTransferReceivable', {
            ReceivableInfo: dataProvider.getBaseReceivableInfoDto(),
            SourceDebitCard: this.sourceCardNo,
            DestinationDebitCard: this.debitCardSelector.selectedItem.id,
            TraceCode: this.traceCode
        });
    }
    validate(): string[] {
        let result = [];
        if (stringIsNullOrEmpty(this.sourceCardNo)) {
            result.push(translate("debitGateway-viewModel.soruceCardError", {}));
        }
        if (!stringIsNullOrEmpty(this.sourceCardNo) && this.sourceCardNo.length < 16) {
            result.push(translate("debitGateway-viewModel.soruceCardLenthError", {}));
        }
        if (stringIsNullOrEmpty(this.traceCode)) {
            result.push(translate("debitGateway-viewModel.trackingCodeError", {}));
        }
        if (this.debitCardSelector.selectedItem == null) {
            result.push(translate("debitGateway-viewModel.destinationCardError", {}));
        }
        return result;
    }
}
